export default {"src":"/coding-school/_next/static/media/Logo.2f027f98.svg","height":38,"width":76,"blurWidth":0,"blurHeight":0};